import React from "react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast, { Toaster } from 'react-hot-toast';
;
import UserProfile from "components/UserProfile/UserProfile";
import $ from 'jquery';
import * as XLSX from "xlsx";
import API from "components/Apis/API";
import { saveAs } from 'file-saver';


// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Navbar,
  Nav,
  Table,
  Container,
  Row,
  Col,
  Modal,
  Alert,
} from "react-bootstrap";

function InvoiceToExcel() {
  const [show, setShow]  = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = ()  => setShow(true);
  const [invoices, setInvoices] = useState([]);
  
  const { register, formState: { errors }, handleSubmit } = useForm();

  const fetchInvoice = async () => {
    const toastId = toast.loading("Fetching invoice data...");
    const url   = await ""+"admin/get_invoice";
    const token = await UserProfile.getToken();
    const formData = new FormData($('.singleOrderForm')[0]);
    const response = await API.postData(url,formData)
    const rsp = response
    if(rsp.status)
    {
      let check = false;
      toast.dismiss(toastId);
      console.log(rsp.data);
      invoices.map((row,i)=> {
        if(row["Pro Number"] == rsp.data["Pro Number"])
        {
          check=true;
        }
      })
      if(!check)
      {
        toast.success(rsp.msg);
        await setInvoices(current => {
          return [
            ...current,
            rsp.data
          ];
        });
      }
      else
      {
        toast.error("Invoice already added");
      }
      handleClose()
    }
    else
    {
      toast.dismiss(toastId);
      toast.error(rsp.msg);
    } 
  }

  const removeInvoice = async (indexToRemove) => {
    setInvoices((prevArray) =>
      invoices.filter((_, index) => index !== indexToRemove)
    );
  }

  const downloadExcel = async () => {
    const toastId = toast.loading("Downloading excel file...");

    if(invoices.length == 0)
    {
      toast.error("Invoices not available for excel!");
    }
    else
    {
      const url   = await ""+"admin/download_invoices";
      let rsp = await API.postData(url,invoices,true);
      if(rsp)
      {
        saveAs(rsp, invoices[0]['Pro Number']+".xlsx");
      }
      toast.dismiss(toastId);
    }

  }

  return (
    <>
      <Toaster position="bottom-right" />
      <Container fluid>
        <Row>
          <Col md="12">
            <Card className="strpied-tabled-with-hover">
              <Card.Header>
                <Card.Title as="h4">
                  Invoices
                  <span style={{float: 'right'}}>
                    <button className="btn btn-primary btn-sm tbtn terminal_1" style={{margin:'5px'}} onClick={() => downloadExcel()}>Download Excel({(invoices.length)})</button>  
                    <button className="btn btn-primary btn-sm tbtn terminal_1" style={{margin:'5px'}} onClick={() => handleShow()}>Fetch Invoice</button>  
                  </span>
                </Card.Title>
              </Card.Header>
              <Card.Body className="table-full-width table-responsive px-0">
                <Table className="table-hover table-striped">
                  <thead>
                    <tr>
                      <th className="border-0">Invoice Number</th>
                      <th className="border-0">Print Date</th>
                      <th className="border-0">Total Miles</th>
                      <th className="border-0">Total Charges</th>
                      <th className="border-0">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoices.map((row,i)=> (
                    <tr>
                      <td>{row["Pro Number"]}</td>
                      <td>{row["Invoice Date"]}</td>
                      <td>{row["Miles"]}</td>
                      <td>{row["Total Charges"]}</td>
                      <td><button className="btn btn-warning btn-xs" onClick={() => removeInvoice(i)}><i className="fa fa-trash"></i></button></td>
                    </tr>
                   ))}
                    
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <Modal show={show} onHide={handleClose} className=" ">
              <Modal.Header>
                  <Modal.Title style={{width:'100%',margin:'0 0 0'}}>Add invoice data
                  </Modal.Title>
              </Modal.Header>
              <form onSubmit={handleSubmit(fetchInvoice)} className="singleOrderForm">
                  <Modal.Body style={{paddingTop:"10px"}}>
                      <Table className="table-hover table-striped" style={{width:'100%',margin:'0 0 0'}}>
                      <tbody>
                          <tr>
                              <th>Pro:</th>
                              <td><input
                                  name="pro_no"
                                  type="text"
                                  className="form-control mt-1 modalInput"
                                  placeholder="Enter pro number"
                                 
                                  />
                              </td>
                          </tr>
                          <tr>
                              <th>Invoice Sequence:</th>
                              <td><input
                                  name="sequence"
                                  type="number"
                                  className="form-control mt-1 modalInput"
                                  placeholder="Enter invoice sequence eg 0"
                                
                                  />
                              </td>
                          </tr>
                          <tr>
                              <th>Invoice Letter:</th>
                              <td><input
                                  name="letter"
                                  type="text"
                                  className="form-control mt-1 modalInput"
                                  placeholder="Enter invoice letter eg. A"
                                  />
                              </td>
                          </tr>
                          
                      </tbody>
                      </Table> 
                  </Modal.Body>
                  <Modal.Footer>
                      <Button variant="secondary" onClick={handleClose}>
                      Close
                      </Button>
                      <Button variant="primary" type="submit">
                      Fetch Invoice
                      </Button>
                  </Modal.Footer>
              </form>
          </Modal>
    </>
  );
}

export default InvoiceToExcel;
 